import React from 'react'
import BasePopup from '../Popup'
import styled from "styled-components";
import ImgChangeCoin from '../../../../../assets/images/Event-2026/change-coin.png';
import ImgChangeCoinTBN from '../../../../../assets/images/Event-2026/change-coinTBN.png';
import ImgCongrat from '../../../../../assets/images/Event-2026/congrat.png';
import ImgCongratTBN from '../../../../../assets/images/Event-2026/congrats-ribbonTBN.png';
import ImgExit from '../../../../../assets/images/Event-2026/exit.png';
import ImgChangeBid from '../../../../../assets/images/Event-2026/popup-change-bid.png';
import ImgBackChangeCoin from '../../../../../assets/images/Event-2026/back-change-coin.png';
import ImgCoin from '../../../../../assets/images/Event-2026/popup-coin.png';
import { useTranslation } from 'react-i18next';

const PopupContent = ({ type, bid, submit, isLoading, data }) => {
  const { t } = useTranslation()

  if (type === "success") {
    return (
      <>
        <p className="text">{t('you_have_received')}</p>
        <div className="content-text attempts-success">
          <p className="high">{bid} {t('coins')}</p>
          <img src={ImgCoin} alt="" className="img-bid" />
        </div>
        <button onClick={submit} className="btn">
          {t('earn_more_pieces')}
        </button>
      </>
    );
  }
  if (type === "daily") {
    return (
      <>
        <p className="text">{t('you_have_received')}</p>
        <div className="content-text attempts-success">
          <p className="high">{data[0]?.normal_coin} {t('coins')}</p>
          <p>{t('from_mission_to_earn_coins')} -</p>
          <p>{data[0]?.name || ""}</p>
          <img src={ImgCoin} alt="" className="img-bid" />
        </div>
        <button onClick={submit} className="btn">
          {t('earn_more_pieces')}
        </button>
      </>
    );
  }

  return (
    <>
      <p className="text">{t('change_1_coin_1_bid')}</p>
      <img src={ImgChangeBid} alt="" className="img-bid" />
      <div className="content-text">
        <p>{t('you_want_to_change')}:</p>
        <p className="high">{bid} {t('coins')}</p>
        <p className="high-1">(- {bid} {t('bids')})</p>
      </div>
      <button onClick={submit} className="btn">
        {isLoading ? t('loading') : t('confirms')}
      </button>
    </>
  );
};
export default function PopupChangeCoin({
  visible,
  setVisible,
  submit,
  bid,
  type,
  isLoading = false,
  data
}) {
  const { i18n } = useTranslation()

  let imgs;
  if (type === "success" || type === "daily") {
    imgs = i18n.language === 'en' ? ImgCongrat : ImgCongratTBN;
  }

  if (type === "change") {
    imgs = i18n.language === 'en' ? ImgChangeCoin : ImgChangeCoinTBN;
  }

  return (
    <BasePopup
      visible={visible}
      onCancel={() => setVisible(false)}
      getContainer
    >
      <ChangeCoin>
        <div className="popup-change-coin">
          <div className="exit">
            <img
              src={ImgExit}
              alt=""
              onClick={() => setVisible(false)}
            />
          </div>

          <img
            src={imgs}
            alt=""
            className="logo-change-coin"
          />

          <PopupContent
            type={type}
            bid={bid}
            submit={submit}
            isLoading={isLoading}
            data={data}
          />
        </div>
      </ChangeCoin>
    </BasePopup>
  );
}
const ChangeCoin = styled.div`
  .popup-change-coin{
    position: relative;
    background-image: url(${ImgBackChangeCoin});
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
    text-align: center;
    z-index: 999999;
    
    @media (min-width: 768px) {
           min-height: 100%;
    }
		.img-bid {
			width: 100%;
			height: auto;
      max-width: 290px;
			object-fit: contain;

			@media (max-width: 768px) {
				max-width: 265px;
			}
		}
    .exit{
      position: absolute;
      top: 2%;
      right: 2%;

      img{
         height: 40px;
        width: 40px;
        object-fit: contain;
        cursor: pointer;
      }
    }

    .content-text p,
    .text{
      color: #fff;
      font-size: 16px;
      font-weight: 600;
    }
    .logo-change-coin{
      padding-top: 70px;
    }
    .content-text{
      p{
        padding-top: 10px;
      }
     
      .high-1,
      .high{
        font-size: 40px;
        line-height: 40px;
        font-weight: 900;
        margin-bottom: 10px;
        background: linear-gradient(
        180deg,
        #FEFDFA 28%,
        #FED58A 57%,
        #F7CA27 73%,
        #FDF2B5 92%
      );
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;
      filter: drop-shadow(0px 2.07px 0.69px rgba(14, 0, 137, 1));
      }
      .high-1{
        font-size: 25px;
        line-height: 30px;
      }
    }

		.attempts-success{
			p{
				padding: 0;
				margin: 0;
				line-height: 18px;
			}
			.img-bid{
				width: 100%;
				height: 130px;
        margin: 20px;
				@media (max-width: 768px) {
					max-width: 100px;
          margin: 0px;
				}
			}
		}
    .btn{

      cursor: pointer;
      border: none;
      outline: none;
      width: calc(100% - 120px);
      max-width: 100%;
      padding: 10px 20px;
      font-size: 16px;
      color: #fff;
      margin: 10px 40px 20px 40px;
      font-weight: 600;
      border-radius: 5px;
      background: linear-gradient(
      180deg,
      rgba(30, 163, 23, 1) 0%,
      rgba(25, 184, 16, 1) 100%
    );
    }
  }
`
